export const parseLinks = (text: string) => {
    const urlRegex = /(https?:\/\/|www\.)[^\s<]+|\b([a-z0-9-]+\.){1,}[a-z]{2,}(\/[^\s<]*)?/gi;
    return text.replace(urlRegex, (url) => {
      const fullUrl = url.startsWith("www.")
        ? `https://${url}`
        : !url.match(/^https?:\/\//) && url.includes(".")
          ? `https://${url}`
          : url;
      return `<a href="${fullUrl}" target="_blank">${url}</a>`;
    });
  };
